import React, { useEffect, useState } from "react";
import useAlert from "../../hook/useAlert";
import useBetWin from "../../redux/betWinData/betWinAction";
import HistoryRound from "./HistoryRound";
import styles from "./index.module.scss";
import Config from "../../utils/Config";

let hdlTimeout = null;
// let shoBonusBtn = false;

function BetWinPanel() {
  const roundPerPage = 8;
  const {
    betWinData,
    historyTriggered,
    wScale,
    hScale,
    setHistoryTriggered,
    bonusState,
  } = useBetWin();
  const { showAlert } = useAlert();

  //===========================================================================
  const [betWinType, setBetWinType] = useState(0);
  const [spinCountPerRotate, setSpinCountPerRotate] = useState(1);
  const [totalBetDevided, setTotalBetDivided] = useState(100);
  const [fontSize, setFontSize] = useState(16);
  const [betWins, setBetWins] = useState([]);
  const [curIndex, setCurIndex] = useState(0);
  const [curBetWin, setCurBetWin] = useState(null);

  const [bonusType, setBonusType] = useState(0);
  const [joinBonus, setJoinBonus] = useState(false);
  const [winABase, setWinABase] = useState(10);
  const [winBBase, setWinBBase] = useState(10);
  const [winAToBonus, setWinAToBonus] = useState(0);
  const [winBToBonus, setWinBToBonus] = useState(0);

  useEffect(() => {
    // shoBonusBtn = Config.showBonusBtn ? Config.showBonusBtn : false;
    componentDidMount();
    return componentWillUnmount;
  }, []);

  useEffect(() => {
    if (bonusState) {
      setBonusType(bonusState.bonusType);
      setJoinBonus(bonusState.joinBonus);
      setWinABase(bonusState.winABase);
      setWinBBase(bonusState.winBBase);
      setWinAToBonus(bonusState.winAToBonus);
      setWinBToBonus(bonusState.winBToBonus);
    } else {
      setBonusType(0);
      setJoinBonus(false);
      setWinABase(10);
      setWinBBase(10);
      setWinAToBonus(0);
      setWinBToBonus(0);
    }
  }, [bonusState]);

  useEffect(() => {
    // if got new betWinData, back to index 0 immediately
    if (betWinData) {
      setBetWinType(betWinData.betWinType);
      setSpinCountPerRotate(betWinData.spinCountPerRotate);
      setTotalBetDivided(
        betWinData.totalBetDivided ? betWinData.totalBetDivided : 100
      );
      setBetWins(betWinData.betWins ? betWinData.betWins : []);
    } else {
      setBetWinType(0);
      setSpinCountPerRotate(1);
      setTotalBetDivided(100);
      setBetWins([]);
    }
    setCurIndex(0);
  }, [betWinData]);

  useEffect(() => {
    if (historyTriggered) {
      if (curIndex + 1 < betWins.length) setCurIndex(curIndex + 1);
      setHistoryTriggered(false);
    }
  }, [historyTriggered]);

  useEffect(() => {
    const fScale = wScale > hScale ? wScale : hScale;
    //setFontSize(Math.floor(50 * fScale));
    setFontSize(Math.floor(40 * fScale));
    console.log(`fScale:${fScale}`);
  }, [wScale, hScale]);

  useEffect(() => {}, [betWinType]); // 依賴於 betWinType 的變化

  useEffect(() => {
    // if index isn't 0, back to index 0 in 10 seconds
    if (curIndex > 0) {
      const betWin = betWins.length > curIndex ? betWins[curIndex] : null;
      setCurBetWin(betWin);

      if (hdlTimeout) {
        console.log("清除舊的計時器");
        clearTimeout(hdlTimeout);
      }

      hdlTimeout = setTimeout(function () {
        console.log("執行 setCurIndex");
        setCurIndex(0);
        hdlTimeout = null;
      }, 10000);
    } else {
      const betWin = betWins.length > 0 ? betWins[0] : null;
      setCurBetWin(betWin);
    }
  }, [betWins, curIndex]);
  //===========================================================================

  function componentDidMount() {}

  function componentDidUpdate() {}

  function componentWillUnmount() {}

  function getBetWinText(betWinType, curBetWin) {
    switch (betWinType) {
      case 1:
        return "RB: " + (curBetWin ? curBetWin.WinB : 0);
      case 2:
        return "連莊: " + (curBetWin ? curBetWin.WinB : 0);
      default:
        return "大獎:" + (curBetWin ? curBetWin.WinB : 0);
    }
  }

  function getShowRows(betWinType) {
    // 將兩個 JSX 元素分別存儲
    const firstRow = (
      <div
        style={{
          color: "#ff7f7f",
          fontSize: `${fontSize}px`,
          borderBottomWidth: "1px",
          borderBottomStyle: "solid",
          borderBottomColor: "#7171e9",
        }}
      >
        BB: {curBetWin ? curBetWin.WinA : 0}
      </div>
    );

    const secondRow = (
      <div style={{ color: "#7f7fff", fontSize: `${fontSize}px` }}>
        {getBetWinText(betWinType, curBetWin)}
      </div>
    );

    const oneRowOnly = (
      //<div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ color: "#ff7f7f", fontSize: `${fontSize}px` }}>
        {getBetWinText(betWinType, curBetWin)}
      </div>
      //</div>
    );

    // 將兩個 JSX 元素分別存儲
    const firstRowWithBonusState = (
      <div
        style={{
          color: "#ff7f7f",
          fontSize: `${fontSize}px`,
          borderBottomWidth: "1px",
          borderBottomStyle: "solid",
          borderBottomColor: "#7171e9",
        }}
      >
        BB: {curBetWin ? curBetWin.WinA : 0}
        <br />
        {winAToBonus} : {winABase}
      </div>
    );

    const secondRowWithBonusState = (
      <div style={{ color: "#7f7fff", fontSize: `${fontSize}px` }}>
        {getBetWinText(betWinType, curBetWin)}
        <br />
        {winBToBonus} : {winBBase}
      </div>
    );

    const firstRowWithBonusState_CR = (
      <div
        style={{
          color: "#ff7f7f",
          fontSize: `${fontSize}px`,
          borderBottomWidth: "1px",
          borderBottomStyle: "solid",
          borderBottomColor: "#7171e9",
        }}
      >
        BB: {curBetWin ? curBetWin.WinA : 0}
        <br />
        {winBToBonus} : {winBBase}
      </div>
    );

    const oneRowOnlyWithBonusState = (
      //<div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ color: "#ff7f7f", fontSize: `${fontSize}px` }}>
        {getBetWinText(betWinType, curBetWin)}
        <br />
        {winBToBonus} : {winBBase}
      </div>
      //</div>
    );
    let showfirstRow = firstRow;
    let showsecondRow = secondRow;
    let showoneRowOnly = oneRowOnly;

    if (showBonusState()) {
      switch (bonusType) {
        case 1:
          showfirstRow = firstRowWithBonusState;
          showsecondRow = secondRowWithBonusState;
          break;
        case 2:
        case 3:
          showfirstRow = firstRowWithBonusState_CR;
          break;
        case 4:
        case 5:
          showoneRowOnly = oneRowOnlyWithBonusState;
          break;
        default:
          break;
      }
    }
    // 根據 betWinType 決定渲染哪些元素
    switch (betWinType) {
      case 1:
      case 2:
        return (
          <>
            {showfirstRow}
            {showsecondRow}
          </>
        );
      default:
        return showoneRowOnly;
    }
  }

  function showSpin(betWinType) {
    switch (betWinType) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        return true;
      default:
        return false;
    }
  }

  function showHistoryRound(betWinType) {
    switch (betWinType) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        return true;
      default:
        return false;
    }
  }

  // function handleBonusBtnClick() {
  //   const bonusUrl = `http://35.234.39.253/bonusClient/bonus`;
  //   const content = `<iframe src="${bonusUrl}" style="width:100%;border-width:0px;overflow-y:auto;height:100vh"></iframe>`;

  //   showAlert({
  //     html: content,
  //     showConfirmButton: true,
  //     fullscreen: true,
  //   });
  // }

  function showBonusState() {
    if (!joinBonus || bonusType <= 0) return false;
    else return true;
  }

  return (
      <div className={styles.betWinPanel}>
        <div className={styles.innerContent}>
          {Config.enableBetWinPanel === true ? (
            <>
              {showSpin(betWinType) === true ? (
                <div className={styles.betWin}>
                  <div className={styles.left}>{getShowRows(betWinType)}</div>
                  <div className={styles.right}>
                    <div style={{ color: "#ffff00", fontSize: `${fontSize}px` }}>
                      當前
                    </div>
                    <div
                      style={{
                        color: "#ffffff",
                        fontSize: `${fontSize}px`,
                        paddingTop: "5px",
                      }}
                    >
                      {curBetWin
                        ? Math.floor(curBetWin.TotalBet / spinCountPerRotate)
                        : 0}
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.nonBetWin}>
                  <div className={styles.center}>{getShowRows(betWinType)}</div>
                </div>
              )}
              {showHistoryRound(betWinType) === true ? (
                <div className={styles.historyRound}>
                  {betWins.map((data, index) => {
                    return Math.floor(index / roundPerPage) ===
                      Math.floor(curIndex / roundPerPage) ? (
                      <HistoryRound
                        key={`betWinRound_${index}`}
                        betWinType={betWinType}
                        spinCountPerRotate={spinCountPerRotate}
                        totalBetDivided={totalBetDevided}
                        betWin={data}
                        onFocus={curIndex === index ? true : false}
                      />
                    ) : null;
                  })}
                </div>
              ) : null}
              </>
          ) : null}
        </div>
        {/* {shoBonusBtn ? (
          <>
            <button
              className={styles.bonusBtn}
              onClick={handleBonusBtnClick}
              onMouseDown={handleBonusBtnClick}
              onTouchStart={handleBonusBtnClick}
            >
              大獎
            </button>
          </>
        ) : null} */}
      </div>
  );

  
}

export default BetWinPanel;
